<script setup lang="ts">
import type { Image } from "~/types/common";
export type SocialIconsProps = {
  text?: string;
  items?: { name: string; link: string; image: Image }[];
  url?: string;
  title?: string;
};

const props = defineProps<SocialIconsProps>();
const socialUrl = computed(() => {
  return props.url ? `${props.url}` : "";
});
</script>

<template>
  <div class="d-flex justify-content-end mt-20 mb-20 gap-2">
    <span>{{ props?.text }}</span>
    <div class="d-flex gap-1">
      <a
        v-for="item in props?.items"
        :key="item.name"
        :href="item.link + socialUrl"
        target="_blank"
        class="social-icon"
      >
        <img
          :src="$getStrapiImageSrc(item.image)"
          class="img-fluid"
          width="25"
        />
      </a>
    </div>
  </div>
</template>
